import { serializeObject } from "../common/helper";
import { Request } from "../services/HttpService";
const URL = "vitae/technologysubcategory";
export const TechnologySubCategoryService = {
  GetAll() {
    return Request(URL, "GET");
  },
  getAllSubCategories(pageSize, pageNumber, searchObject) {
    return Request(
      `${URL}/${pageSize}/${pageNumber}?${serializeObject(searchObject)}`
    );
  },
  getById(technologySubCategoryId) {
    return Request(`${URL}/${technologySubCategoryId}`);
  },
  createOrUpdate(technologySubcategory) {
    return Request(
      URL,
      technologySubcategory.id ? "PUT" : "POST",
      technologySubcategory
    );
  },
  delete(id) {
    return Request(`${URL}/${id}`, "DELETE");
  }
};
